<template>
  <div>
    <div class="form-group row" v-if="saving_params.is_bpjs">
      <label class="col-sm-1 pr-0 label_kesadaran col-form-label">Kesadaran <span style="color:red"> *</span></label>
      <div class="col-sm-5">
        <vue-select
          :options="kesadaran.options"
          :value="kesadaran.selected"
          placeholder="Pilih Kesadaran"
          class="custom_select"
          id="kesadaran"
          @input="updateKdSadar"
        >
          <template slot="option" slot-scope="option">
            {{ option.label }}
          </template>
          <template slot="selected-option" slot-scope="option">
            {{ option.label }}
          </template>
        </vue-select>
      </div>
    </div>
    <div class="form-group row mb-4">
      <div class="col-md-6">
        <label class="pr-0 label_kesadaran col-form-label">Tingkat Kesadaran</label>
        <br>
        <vue-select
          :options="option_tingkat_kesadaran"
          v-model="selectedTingkatKesadaran"
          placeholder="Pilih Tingkat Kesadaran"
          class="custom_select"
          id="tingkat_kesadaran"
          @input="updateTingkatKesadaran"
        >
          <template slot="option" slot-scope="option">
            {{ option.label }}
          </template>
          <template slot="selected-option" slot-scope="option">
            {{ option.label }}
          </template>
        </vue-select>
      </div>
    </div>
    <div class="row d-flex align-items-end">
      <div class="col-md-6" @click="asyncFind('')">
        <label class="pr-0 label_kesadaran col-form-label">Pilih Organ</label>
        <br>
        <multiselect
          v-model="selectedOrgan"
          :options="organs"
          placeholder="Pilih Organ"
          label="nama"
          track-by="nama"
          open-direction="bottom"
          :multiple="false"
          :loading="isLoading"
          :clear-on-select="true"
          :close-on-select="true"
          :hide-selected="true"
          @search-change="debounceSearch"
        ></multiselect>
      </div>
      <div class="col-md-3 offset-md-3">
        <div class="row d-flex justify-content-end mr-2">
          <div>
            <input type="range" class="custom-range" min="1" max="50" v-model.number="penWidth" />
          </div>
        </div>
        <div class="row d-flex justify-content-end mr-2">
          <div>
            <span
              @click="penColor('blue');isColorActive = 'blue'"
              class="dot grow"
              style="background-color: blue;"
              :class="{ color_active: isColorActive === 'blue' }"
            ></span>
            <span
              @click="penColor('red');isColorActive = 'red'"
              class="dot grow"
              style="background-color: red;"
              :class="{ color_active: isColorActive === 'red' }"
            ></span>
            <span
              @click="penColor('#54c756');isColorActive = 'green'"
              class="dot grow"
              style="background-color: #54c756;"
              :class="{ color_active: isColorActive === 'green' }"
            ></span>
            <span
              @click="penColor('#555');isColorActive = 'black'"
              class="dot grow"
              style="background-color: #555;"
              :class="{ color_active: isColorActive === 'black' }"
            ></span>
            <span
              @click="penColor('orange');isColorActive = 'yellow'"
              class="dot grow"
              style="background-color: orange;"
              :class="{ color_active: isColorActive === 'yellow' }"
            ></span>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-7 px-2">
        <canvas
          id="pemeriksaan-canvas"
          ref="canvas"
          @mousedown="handleMousedown"
          @mouseup="handleMouseup"
          @mousemove="handleMousemove"
          @touchstart="handleTouchstart"
          @touchend="handleTouchend"
          @touchmove="handleTouchmove"
          width="700"
          height="370"
        >Your browser does not support the HTML 5 Canvas.
        </canvas>
      </div>
      <div v-if="isActive == 'keyboard'" class="col-md-5 pl-5 pr-2">
        <Editor id="editor" :editorContent="pemeriksaan" v-on:update-content="updateContent" />
      </div>
      <div v-show="isHidden" class="col-md-12">
        <div id="img_organ"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <b-button @click="clearCanvas" variant="warning" size="sm" class="m-1">Clear</b-button>
      </div>
    </div>

    <b-row class="mt-4 pointer" @click="clickOpsi('pemeriksaan_fisik')">
      <b-col sm="6">
        <strong>Pemeriksaan Fisik</strong>
      </b-col>
      <b-col sm="6" class="text-right">
        <font-awesome-icon icon="chevron-down" v-if="!click['pemeriksaan_fisik']" />
        <font-awesome-icon icon="chevron-up" v-else />
      </b-col>
      <b-col sm="12">
        <hr class="my-2 hr-blue">
      </b-col>
    </b-row>
    <b-row class="row px-4 pt-4 pb-0" v-if="click['pemeriksaan_fisik']">
      <template v-for="form in formBasicData">
        <b-col
          :sm="form.col"
          :lg="form.colLg"
          :key="form.tmpId"
          :class="form.class"
          v-if="form.type == 'pemeriksaan_fisik'"
        >
          <b-form-group class="text-capitalize">
            <template v-if="form.rawLabel == 'luas fisik'">
              <strong style="font-size : 13px; color: grey;">{{ setLabel(form.rawLabel) }}</strong>
              <br>
              <b-input-group>
                <template #append v-if="form.satuan">
                  <b-input-group-text class="custom_append">{{ form.satuan }}</b-input-group-text>
                </template>
                <b-form-input
                  type="text"
                  v-model.lazy="formData[form.label]"
                  @input="
                    setValue({
                      rawLabel: form.rawLabel,
                      label: form.label,
                      $event,
                      tmpId: form.tmpId
                    })
                  "
                  @keypress="
                    onKeyInputNumber({
                      label: form.label,
                      rawLabel: form.rawLabel,
                      $event
                    })
                  "
                  class="mb-2 mt-2"
                />
              </b-input-group>
            </template>
            <template v-else-if="form.rawLabel.includes('ket')">
              <br />
              <b-form-input
                :class="{ 'is-invalid': form.error }"
                :ref="form.label"
                type="text"
                v-model.lazy="formData[form.label]"
                class="mt-2"
                @input="
                  setValue({
                    rawLabel: form.rawLabel,
                    label: form.label,
                    $event,
                    tmpId: form.tmpId
                  })
                "
                :disabled="!formData[form.label.replace('ket_','')] || (formData[form.label.replace('ket_','')] && formData[form.label.replace('ket_','')].value != 'Y')"
              />
              <b-form-invalid-feedback
                style="text-transform: none"
                :state="renderError({ error: form.error })"
              >
                Kolom harus diisi
              </b-form-invalid-feedback>
            </template>
            <template v-else>
              <strong style="font-size : 13px; color: grey;">{{ setLabel(form.rawLabel) }}</strong>
              <br />
              <vue-select
                :class="{ error: form.error }"
                :options="option_pemeriksaan_fisik"
                :placeholder="form.placeholder"
                v-model="formData[form.label]"
                class="__form-select mt-2"
                @input="
                  setValue({
                    rawLabel: form.rawLabel,
                    label: form.label,
                    $event,
                    tmpId: form.tmpId
                  })
                "
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
      </template>
    </b-row>

    <b-row class="mt-4 pointer" @click="clickOpsi('pemeriksaan_lainnya')">
      <b-col sm="6">
        <strong>Pemeriksaan Psikologis, Sosial Ekonomi, Spiritual</strong>
      </b-col>
      <b-col sm="6" class="text-right">
        <font-awesome-icon icon="chevron-down" v-if="!click['pemeriksaan_lainnya']" />
        <font-awesome-icon icon="chevron-up" v-else />
      </b-col>
      <b-col sm="12">
        <hr class="my-2 hr-blue">
      </b-col>
    </b-row>
    <b-row class="row px-4 pt-4 pb-0 mb-75" v-if="click['pemeriksaan_lainnya']">
      <template v-for="form in formBasicData">
        <b-col
          :sm="form.col"
          :lg="form.colLg"
          :key="form.tmpId"
          :class="form.class"
          v-if="form.type == 'pemeriksaan_lainnya'"
        >
          <b-form-group class="text-capitalize">
            <template v-if="form.label == 'status_psikologis'">
              <strong style="font-size : 13px; color: grey;">{{ setLabel(form.rawLabel) }}</strong>
              <vue-select
                :class="{ error: form.error }"
                :options="option_pemeriksaan_lainnya"
                :placeholder="form.placeholder"
                v-model="formData[form.label]"
                class="__form-select mt-2"
                @input="
                  setValue({
                    rawLabel: form.rawLabel,
                    label: form.label,
                    $event,
                    tmpId: form.tmpId
                  })
                "
              >
              </vue-select>
            </template>
            <template v-else-if="form.rawLabel == 'ket_status_psikologis'">
              <br />
              <b-form-input
                :class="{ 'is-invalid': form.error }"
                :ref="form.label"
                type="text"
                v-model.lazy="formData[form.label]"
                class="mt-2"
                @input="
                  setValue({
                    rawLabel: form.rawLabel,
                    label: form.label,
                    $event,
                    tmpId: form.tmpId
                  })
                "
                :disabled="!formData['status_psikologis'] || (formData['status_psikologis'] && formData['status_psikologis'].value != 'L')"
              />
              <b-form-invalid-feedback
                style="text-transform: none"
                :state="renderError({ error: form.error })"
              >
                Kolom harus diisi
              </b-form-invalid-feedback>
            </template>
            <template v-else>
              <strong style="font-size : 13px; color: grey;">{{ setLabel(form.rawLabel) }}</strong>
              <br />
              <b-form-input
                class="mb-2 mt-2"
                :ref="form.label"
                type="text"
                v-model.lazy="formData[form.label]"
                @input="
                  setValue({
                    rawLabel: form.rawLabel,
                    label: form.label,
                    $event,
                    tmpId: form.tmpId
                  })
                "
              />
            </template>
          </b-form-group>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store/";
import { mapGetters, mapActions } from "vuex";
import Editor from "./Editor";
import Multiselect from "vue-multiselect";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
library.add(faChevronDown, faChevronUp);
import debounce from "lodash/debounce";

const tmp = [
  {
    label: "luas fisik",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 6,
    class: 'mt-6',
    satuan: 'm2',
    validations: {}
  },
  {
    label: "kepala",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_kepala",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "mata",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_mata",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "telinga",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_telinga",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "hidung",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_hidung",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "rambut",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_rambut",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "bibir",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_bibir",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "gigi geligi",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_gigi_geligi",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "lidah",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_lidah",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "langit langit",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_langit_langit",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "leher",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_leher",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "tenggorokan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_tenggorokan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "tonsil",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_tonsil",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "dada",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_dada",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "payudara",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_payudara",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "punggung",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_punggung",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "perut",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_perut",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "genital",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_genital",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "anus",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_anus",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "lengan atas",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_lengan_atas",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "lengan bawah",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_lengan_bawah",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "jari tangan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_jari_tangan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "kuku tangan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_kuku_tangan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "persendian tangan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_persendian_tangan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "tungkai atas",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_tungkai_atas",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "tungkai bawah",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_tungkai_bawah",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "jari kaki",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_jari_kaki",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "kuku kaki",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_kuku_kaki",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "persendian kaki",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_persendian_kaki",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "status psikologis",
    type: "pemeriksaan_lainnya",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_status_psikologis",
    type: "pemeriksaan_lainnya",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "sosial ekonomi",
    type: "pemeriksaan_lainnya",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
  {
    label: "spiritual",
    type: "pemeriksaan_lainnya",
    col: 12,
    colLg: 3,
    class: 'mb-3',
    placeholder: "",
    validations: {}
  },
];

export default {
  name: "Pemeriksaan",
  components: {
    Multiselect,
    Editor,
    "vue-select": () => import("@/components/VueSelectClearable.vue"),
  },
  data() {
    return {
      editData: {},
      isHidden: true,
      isDrawing: false,
      drawing: false,
      mousePos: { x: 0, y: 0 },
      lastPos: { x: 0, y: 0 },
      ctx: null,
      image_url: null,
      isLoading: false,
      selectedOrgan: [],
      organs: [],
      isPen: true,
      isActive: "keyboard",
      isColorActive: "black",
      penWidth: 2,
      ediRekamMedis: {},
      pemeriksaan: null,
      formBasicData: null,
      formData: null,
      selectedTingkatKesadaran: null,

      click: {
        pemeriksaan_fisik: false,
        pemeriksaan_lainnya: false,
      },
      option_tingkat_kesadaran: [
        { value: 'Sadar baik', label: 'Sadar baik' },
        { value: 'Berespon dengan kata-kata', label: 'Berespon dengan kata-kata' },
        { value: 'Hanya berespon jika dirangsang', label: 'Hanya berespon jika dirangsang' },
        { value: 'Pasien tidak sadar', label: 'Pasien tidak sadar' },
        { value: 'Gelisah atau bingung', label: 'Gelisah atau bingung' },
        { value: 'Acute Confusional', label: 'Acute Confusional' },
      ],
      option_pemeriksaan_fisik: [
        { label: 'Tidak Diperiksa', value: 'N' },
        { label: 'Tidak Ada Kelainan', value: 'T' },
        { label: 'Ada Kelainan', value: 'Y' }
      ],
      option_pemeriksaan_lainnya: [
        { label: 'Tidak Ada Kelainan', value: 'N' },
        { label: 'Cemas', value: 'C' },
        { label: 'Takut', value: 'T' },
        { label: 'Marah', value: 'M' },
        { label: 'Sedih', value: 'S' },
        { label: 'Lain-Lain', value: 'L' }
      ],
      selectedType: {
        pemeriksaan_fisik: 'Y',
        pemeriksaan_lainnya: 'L'
      },
    };
  },
  computed: {
    ...mapGetters([
      "getKlinikId",
      "kesadaran",
      "saving_params",
    ]),
    canvas: function() {
      return this.$refs.canvas;
    },
  },
  watch: {
    // on organ selected, do something
    selectedOrgan: function() {
      document.getElementById("box_pemeriksaan_fisik").style.setProperty('border-color', '');
      // update the payload
      this.updatePostData({ key: "organ_id", value: this.selectedOrgan ? this.selectedOrgan.id : null });
      if (this.selectedOrgan) this.updatePostData({ key: "pemeriksaan_is_draw", value: true });
      // to render the image
      this.organChanged();
    },
  },
  methods: {
    ...mapActions(["updatePostData", "updateCanvas", "updateKesadaran"]),
    updateContent(content) {
      this.updatePostData({ key: "pemeriksaan_text", value: content });
    },
    setPemeriksaanData(d) {
      if (d.pemeriksaan_fisik) {
        this.pemeriksaan = d.pemeriksaan_fisik.notes
        this.selectedOrgan = {
          id: d.pemeriksaan_fisik.organ_id,
          nama: d.pemeriksaan_fisik.nama_organ,
          gambar: d.pemeriksaan_fisik.is_draw ? d.pemeriksaan_fisik.draw_path : null
        }
        this.selectedTingkatKesadaran = this.option_tingkat_kesadaran.find(k => k.value == d.pemeriksaan_fisik.tingkat_kesadaran);
        this.editData = d.pemeriksaan_fisik;
        this.setFormDataValue(d.pemeriksaan_fisik);
      }
    },
    organChanged() {
      // get the image URL
      let self = this;
      self.image_url = self.selectedOrgan.gambar;
      self.clear();
      self.drawBackground(self.image_url);
    },
    // draw the image
    drawBackground(image_url) {
      let self = this;
      var canvas = document.getElementById("pemeriksaan-canvas"),
        ctx = canvas.getContext("2d"),
        img_organ = document.getElementById("img_organ");

      let backgroundURL = image_url;

      var background = new Image();
      background.crossOrigin = "Anonymous";
      background.src = backgroundURL;

      //remove existing image
      if (img_organ.hasChildNodes()) {
        img_organ.innerHTML = "";
      }

      background.onload = function() {
        let newSize = { width: background.width, height: background.height };
        if (background.width > 700) {
          newSize = self.resizeImage(background);
        }
        ctx.drawImage(background, 0, 0, newSize.width, newSize.height);
      };
      this.isDrawing = true;
    },
    resizeImage(background) {
      let width = background.width,
        height = background.height,
        screen_width = screen.width;

      if(screen_width > 1366) width = 0.41 * screen_width;
      else width = 0.46 * screen_width;
      height = height * (width / background.width); //0.5 * height;

      return { width, height };
    },
    handleMousedown(e) {
      this.lastPos = this.getMousePos(e);
      this.ctx.lineWidth = this.penWidth;
      this.drawing = true;
    },
    handleMouseup(e) {
      this.drawing = false;
    },
    handleMousemove(e) {
      this.mousePos = this.getMousePos(e);
      if (this.drawing) {
        this.ctx.beginPath();
        if (this.isPen) {
          this.ctx.globalCompositeOperation = "source-over";
          this.ctx.moveTo(this.lastPos.x, this.lastPos.y);
          this.ctx.lineTo(this.mousePos.x, this.mousePos.y);
          this.ctx.stroke();
        } else {
          this.ctx.globalCompositeOperation = "destination-out";
          this.ctx.arc(
            this.mousePos.x,
            this.mousePos.y,
            this.penWidth,
            0,
            Math.PI * 2,
            false
          );
          this.ctx.fill();
        }
        this.lastPos = this.mousePos;
      }
    },
    handleTouchstart(event) {
      this.mousePos = this.getTouchPos(event);
      let touch = event.touches[0];
      let mouseEvent = new MouseEvent("mousedown", {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      this.canvas.dispatchEvent(mouseEvent);
    },
    handleTouchend(event) {
      let mouseEvent = new MouseEvent("mouseup", {});
      this.canvas.dispatchEvent(mouseEvent);
    },
    handleTouchmove(event) {
      let touch = event.touches[0];
      let mouseEvent = new MouseEvent("mousemove", {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      this.canvas.dispatchEvent(mouseEvent);
    },
    getMousePos(mouseEvent) {
      const rect = this.canvas.getBoundingClientRect();
      return {
        x: mouseEvent.clientX - rect.left,
        y: mouseEvent.clientY - rect.top
      };
    },
    // Get the position of a touch relative to the canvas
    getTouchPos(touchEvent) {
      const rect = this.canvas.getBoundingClientRect();
      return {
        x: touchEvent.touches[0].clientX - rect.left,
        y: touchEvent.touches[0].clientY - rect.top
      };
    },
    penColor(color) {
      this.ispen = true;
      this.ctx.strokeStyle = color;
    },
    // to get organ datas from backend
    debounceSearch: debounce(function(val) {
      this.asyncFind(val);
    }, 500),
    asyncFind(query) {
      let self = this;
      this.isLoading = true;
      axios
        .get(`${store.state.URL_API}/organ/name?query=${query}&poli_gigi=${this.saving_params.is_poli_gigi}`, {
          headers: {
            Authorization: "Bearer " + store.state.BEARER_TOKEN,
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          let res = response.data;

          if (!res.status) {
            self.isLoading = false;
            return;
          }

          let organs = res.data.organs;

          if (organs) {
            self.organs = organs;
          }

          self.isLoading = false;
        })
        .catch(err => {
          self.isLoading = false;
        });
    },
    clearCanvas() {
      this.selectedOrgan = [];
      this.clear();
    },
    clear() {
      this.canvas.width = this.canvas.width;
    },
    updateKdSadar(event) {
      if (event) {
        this.updateKesadaran({ key: "selected", value: event });
        this.updatePostData({ key: "kdSadar", value: event.value });
      } else {
        this.updateKesadaran({ key: "selected", value: null });
        this.updatePostData({ key: "kdSadar", value: null });
      }
    },
    updateTingkatKesadaran(event) {
      if (event && typeof event == 'object') {
        this.updatePostData({ key: "tingkat_kesadaran", value: event.value });        
      } else {
        this.updatePostData({ key: "tingkat_kesadaran", value: null });
      }
      this.selectedKesadaran = event;
    },
    setFormData() {
      return this.setFormBasicData().reduce((arr, val) => {
        const tmp = val.label.split(" ").join("_");
        arr[tmp] = "";
        return arr;
      }, {});
    },
    setFormDataValue(data) {
      this.formBasicData.forEach(f => {
        if (data.hasOwnProperty(f.label) && f.type == 'pemeriksaan_fisik') {
          if (f.label == 'luas_fisik' || f.label.includes('ket_')) {
            this.formData[f.label] = data[f.label];
          } else {
            this.formData[f.label] = this.option_pemeriksaan_fisik.find(p => p.value == data[f.label]);
          }
        } else if (data.hasOwnProperty(f.label) && f.type == 'pemeriksaan_lainnya') {
          if (f.label == 'status_psikologis') {
            this.formData[f.label] = this.option_pemeriksaan_lainnya.find(p => p.value == data[f.label]);
          } else {
            this.formData[f.label] = data[f.label];
          }
        }
        this.updatePostData({ key: f.label, value: data[f.label] });

        if (f.label.includes('ket_')) {
          f['error'] = this.setValidationErrorKet(f.label.replace('ket_', ''), this.selectedType[f.type], this.formData[f.label]);
        }
      });
      this.$emit('formBasicDataChange', this.formBasicData);
    },
    setFormBasicData() {
      let result = tmp.map((item, index) => ({
        ...item,
        label: item.label.split(" ").join("_"),
        tmpId: index,
        error: null,
        rawLabel: item.label
      }));
      this.$emit('formBasicDataChange', result);
      return result;
    },
    clickOpsi(type) {
      if (this.click.hasOwnProperty(type)) {
        if (this.click[type] == false) {
          this.click[type] = true;
        } else {
          this.click[type] = false;
        }
      }
    },
    setLabel(val) {
      let label = '';
      switch (val) {
        case 'anus':
          label = 'Anus/Dubur';
          break;
        case 'luas fisik':
          label = 'Luas Permukaan Tubuh untuk Anak-Anak';
          break;
        case 'langit langit':
          label = 'Langit-Langit';
          break;
        default:
          label = val;
          break;
      }
      return label;     
    },
    onKeyInputNumber({ label, rawLabel, $event }) {
      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        void this.setValue({
          label,
          rawLabel,
          $event
        });
      }
    },
    setValue({ label, rawLabel, $event = null} = {}) {
        if (label.includes('ket_')) {
          let f_ket = this.formBasicData.find(f => f.label == label);
          f_ket['error'] = this.setValidationErrorKet(label.replace('ket_', ''), this.selectedType[f_ket.type], this.formData[label]);
        } else {
          let f = this.formBasicData.find(f => f.rawLabel == rawLabel);
          if (f && ['pemeriksaan_fisik','pemeriksaan_lainnya'].includes(f.type)) {
            let x = `ket_${label}`;
            let d = this.formData[label];
            if (f && d && d.value != undefined && this.formData.hasOwnProperty(x)) {
              if (d.value != this.selectedType[f.type]) this.formData[x] = null;
              else if (this.editData && d && d.value == this.selectedType[f.type]) this.formData[x] = this.editData.hasOwnProperty(x) ? this.editData[x] : null;
            }

            let f_ket = this.formBasicData.find(f => f.label == x);
            if (f_ket) f_ket['error'] = this.setValidationErrorKet(label, this.selectedType[f.type], this.formData[x]);
          }
      }
      if (typeof $event === "object" && $event != null) {
        this.updatePostData({ key: label, value: $event ? $event.value : null });
      } else {
        this.updatePostData({ key: label, value: $event });
      }
      this.$emit('formBasicDataChange', this.formBasicData);
    },
    setValidationErrorKet(label, type, value) {
      let fd = this.formData[label];
      if (fd && fd.value == type && (!value || value == null || value == '' || value == undefined)) {
        return true;
      } else {
        return false;
      }
    },
    async setPemeriksaanFisik(transklinik_id) {
      const res = await axios.get(`${store.state.URL_API}/transaksi/${transklinik_id}?klinik_id=${this.getKlinikId}`);
      const { success, data } = res.data;
      if (success && data) {
        if (data.pemeriksaan_fisik) {
          this.editData = data.pemeriksaan_fisik;
          this.setFormDataValue(data.pemeriksaan_fisik);
        }
      }
    },
    setDrawPostData(type) {
      if (type == 'pen') {
        this.isPen = true;
        this.isHidden = false;
        this.isDrawing = true;
      } else if (type == 'eraser') {
        this.isPen = false;
        this.isHidden = false;
      } else {
        this.isPen = false;
        this.isHidden = true;
      }
      this.isActive = type;
      this.updatePostData({ key: "diagnosa_is_draw", value: this.isDrawing });
    },
    modalSimbolOdontogram() {
      this.$refs['simbol-odontogram'].show();
    },
  },
  async mounted() {
    this.ediRekamMedis = localStorage.getItem("edit_rekam_medis");
    this.formBasicData = this.setFormBasicData();
    this.formData = this.setFormData();
    await this.setPemeriksaanFisik(this.$router.currentRoute.params.transklinik_id);

    this.ctx = this.canvas.getContext("2d");
    this.ctx.strokeStyle = "#222222";
    this.ctx.lineWidth = this.penWidth;
    this.ctx.lineJoin = "round";
    this.ctx.lineCap = "round";

    //append data canvas to vuex global state
    this.updateCanvas({ key: "PEMERIKSAAN", value: this.canvas });
    this.updatePostData({ key: "pemeriksaan_is_draw", value: false });

    // Get a regular interval for drawing to the screen
    window.requestAnimFrame = (function(callback) {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimaitonFrame ||
        function(callback) {
          window.setTimeout(callback, 1000 / 60);
        }
      );
    })();

    // Prevent scrolling when touching the canvas
    document.body.addEventListener(
      "touchstart",
      function(e) {
        if (e.target == document.getElementById("pemeriksaan-canvas")) {
          e.preventDefault();
        }
      },
      false
    );
    document.body.addEventListener(
      "touchend",
      function(e) {
        if (e.target == document.getElementById("pemeriksaan-canvas")) {
          e.preventDefault();
        }
      },
      false
    );
    document.body.addEventListener(
      "touchmove",
      function(e) {
        if (e.target == document.getElementById("pemeriksaan-canvas")) {
          e.preventDefault();
        }
      },
      false
    );

    if (this.ediRekamMedis != null) {
      this.selectedKesadaran = this.kesadaran.selected
      this.setPemeriksaanData(JSON.parse(this.ediRekamMedis))
    }
  },
};
</script>

<style lang="scss">
  .__form-select
    .vs__dropdown-toggle
    .vs__selected-options
    .vs__search::placeholder {
    color: #d1d2db !important;
    font-size: 12px !important;
    font-weight: 500;
  }

  .custom_select .vs__dropdown-toggle .vs__selected-options .vs__search::placeholder {
    color:#cfcfcf !important;
    font-size: 14px !important;
  }

  .custom_append {
    height: 42px;
    margin-top: 8px;
    background-color: #eeeff8;
    text-transform: lowercase;
  }

  .text-grey {
    font-size: 1rem;
    font-weight: 600;
    color: grey;
  }

  .tooltip .tooltip-inner {
    background: #fff;
    color: #000;
    border-radius: 5px;
    padding: 5px 10px 4px;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
  }

  .tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #fff;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
    z-index: 1;
  }

  .color-info {
    color: #3772d7;
  }

  .head-custom {
    color: grey;
    padding: 1.25rem 0.75rem !important;
    vertical-align: middle !important;
    background-color: #fff !important;
    border-bottom: 2px solid #eee !important;
  }
</style>

<style scoped>
  canvas {
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    cursor: crosshair;
  }

  #pemeriksaan-canvas {
    touch-action: none;
  }

  @media only screen and (max-width: 1400px) {
    .label_kesadaran {
      font-size: 12px;
    }
  }

  .hr-blue {
    border: 0.15rem solid #11c5db;
  }

  .pointer {
    cursor: pointer;
  }

  .table-odontogram {
    border: 2px solid #dcdef1;
  }

  .table-odontogram thead th {
    background: #fff;
  }
  
</style>